import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Modal, useToast } from "@/components/common";
import { formatCurrency } from "@/utils/formatters";
import styles from "./AddInvoiceModal.module.css";
const parseAmountFromDisplay = (value) => {
    const cleaned = value.replace(/[^0-9.-]/g, "");
    return parseFloat(cleaned);
};
/** Format for input with separate $ prefix - returns "1,234.50" without $ */
const formatAmountForInput = (amount) => formatCurrency(amount).replace(/^\$/, "");
export const AddInvoiceModal = ({ isOpen, onClose, onSave, defaultAmount, defaultDescription, }) => {
    const { warning } = useToast();
    const [invoiceAmount, setInvoiceAmount] = useState("");
    const [description, setDescription] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    useEffect(() => {
        if (isOpen) {
            setInvoiceAmount(defaultAmount != null && !Number.isNaN(defaultAmount) && defaultAmount > 0
                ? formatAmountForInput(defaultAmount)
                : "");
            setDescription(defaultDescription ?? "");
        }
    }, [isOpen, defaultAmount, defaultDescription]);
    const handleClose = () => {
        setInvoiceAmount("");
        setDescription("");
        onClose();
    };
    const handleAmountBlur = () => {
        const num = parseAmountFromDisplay(invoiceAmount);
        if (!Number.isNaN(num) && num >= 0) {
            setInvoiceAmount(formatAmountForInput(num));
        }
    };
    const handleSave = async () => {
        const amount = parseAmountFromDisplay(invoiceAmount);
        if (!invoiceAmount.trim() || Number.isNaN(amount) || amount <= 0) {
            warning("Please enter a valid invoice amount");
            return;
        }
        setIsSaving(true);
        try {
            await onSave({
                invoiceAmount: amount,
                description: description.trim(),
            });
            handleClose();
        }
        finally {
            setIsSaving(false);
        }
    };
    return (_jsx(Modal, { isOpen: isOpen, onClose: handleClose, children: _jsxs("div", { className: styles.modalWrapper, children: [_jsx("div", { className: styles.modalHeader, children: _jsx("h2", { className: styles.modalTitle, children: "CREATE INVOICE" }) }), _jsx("div", { className: styles.modalBody, children: _jsxs("div", { className: styles.formStacked, children: [_jsxs("div", { className: styles.formField, children: [_jsx("label", { className: styles.fieldLabel, children: "Invoice Amount" }), _jsx("div", { className: styles.inputWrapper, children: _jsxs("div", { className: styles.amountInput, children: [_jsx("span", { className: styles.currency, children: "$" }), _jsx("input", { type: "text", className: styles.amountField, value: invoiceAmount, onChange: (e) => setInvoiceAmount(e.target.value), onBlur: handleAmountBlur, placeholder: "0.00" })] }) })] }), _jsxs("div", { className: styles.formField, children: [_jsx("label", { className: styles.fieldLabel, children: "Description" }), _jsx("div", { className: styles.inputWrapper, children: _jsx("textarea", { className: styles.textarea, value: description, onChange: (e) => setDescription(e.target.value), placeholder: "The provision of defit services including...", rows: 4 }) })] })] }) }), _jsxs("div", { className: styles.modalFooter, children: [_jsx("button", { className: styles.cancelBtn, onClick: handleClose, children: "Cancel" }), _jsx("button", { className: styles.createBtn, onClick: handleSave, disabled: isSaving, children: isSaving ? "Creating..." : "Create" })] })] }) }));
};
